import { useState } from "react";
import env from "../../../../config/env";
import moment from "moment-timezone";
import {
  MyClassModal,
  SelectReviewTypeModal,
  WriteReviewModal,
} from "./MyClassesModals";

export const MyClassCard: React.FC<{
  classDetails: any;
  classType: string;
}> = ({ classDetails, classType }) => {
  const [isImageLoaded, setIsImageLoaded] = useState<Boolean>(false);
  const [isClassDetailsModalOpen, setIsClassDetailsModalOpen] =
    useState<boolean>(false);
  const [isSelectReviewModalOpen, setIsSelectReviewModalOpen] =
    useState<boolean>(false);
  const [isWriteReviewModalOpen, setIsWriteReviewModalOpen] =
    useState<boolean>(false);
  const [reviewType, setReviewType] = useState<string>("course");

  const isOldSchedule = classDetails?.planning ? false : true;

  const classStartDate = () => {
    if (isOldSchedule) {
      const userTimeZone = moment.tz.guess();
      const scheduleDates = classDetails.scheduleData.schedule.map(
        (date: string) => moment.utc(date).tz(userTimeZone)
      );
      return moment.min(scheduleDates).format("DD MMM YYYY").toUpperCase();
    }
    return "01 DEC 2024";
  };

  const classEndDate = () => {
    if (isOldSchedule) {
      const userTimeZone = moment.tz.guess();
      const scheduleDates = classDetails.scheduleData.schedule.map(
        (date: string) => moment.utc(date).tz(userTimeZone)
      );
      return moment.max(scheduleDates).format("DD MMM YYYY").toUpperCase();
    }
    return "01 DEC 2024";
  };

  const closeClassDetailsModal = () => {
    setIsClassDetailsModalOpen(false);
  };
  const closeSelectReviewModal = () => {
    setIsSelectReviewModalOpen(false);
    setIsClassDetailsModalOpen(false);
  };
  const closeWriteReviewModal = () => {
    setIsWriteReviewModalOpen(false);
    setIsSelectReviewModalOpen(true);
  };

  return (
    <>
      <div
        className="w-full flex justify-start items-center space-x-[8px] md:space-x-[24px] py-[10px] pl-[10px] pr-[10px] md:pr-[30px] border border-white rounded-[16px] bg-white hover:border-[#E2D3FF] hover:bg-[#FDFCFF] transition-all duration-300 cursor-pointer"
        onClick={() => setIsClassDetailsModalOpen(true)}
      >
        {/* class image */}
        <div className="relative w-[134px] md:w-[172px] h-[84px] md:h-[109px] min-w-[134px] md:min-w-[172px] min-h-[84px] md:min-h-[109px] overflow-hidden rounded-[8px] bg-gray-300 flex justify-center items-center">
          {!isImageLoaded && (
            <div className="absolute inset-0 bg-gray-300 animate-pulse"></div>
          )}
          {!isImageLoaded && (
            <div className="absolute inset-0 flex justify-center items-center">
              <span className="animate-spin rounded-full h-6 w-6 border-t-2 border-white"></span>
            </div>
          )}
          <img
            src={`${env.IMAGE_API}${
              classDetails.sessionImage
                ? classDetails.sessionImage.name
                : classDetails.SessionImage.name
            }`}
            alt={`${env.IMAGE_API}${
              classDetails.sessionImage
                ? classDetails.sessionImage.name
                : classDetails.SessionImage.name
            }`}
            className={`w-full h-full object-cover transition-opacity duration-500 ${
              isImageLoaded ? "opacity-100" : "opacity-0"
            }`}
            onLoad={() => setIsImageLoaded(true)}
            loading="lazy"
          />
        </div>
        {/* class title & creators & open button */}
        <div className="w-full flex justify-between items-center">
          {/* class title & creators */}
          <div className="w-full flex flex-col justify-start items-start space-y-[6px] md:space-y-[12px]">
            <span className="font-inter font-semibold text-[16px] md:text-[22px] md:leading-[32px] leading-[25px] text-[#1B0209]">
              {classDetails.title}
            </span>
            <div
              className={`flex justify-start items-center space-x-[8px] md:space-x-[14px] flex-wrap`}
            >
              {/* class creator name */}
              <span className="font-inter font-semibold md:font-normal text-[14px] md:text-[16px] leading-[24px] md:leading-[25px] text-[#1B0209] underline decoration-[#8755E0] decoration-[3px] underline-offset-[8px] text-opacity-80">
                {classDetails.sessionCourse.courseCreator}
              </span>
              {/* class instructor name */}
              {classType === "ongoing" && (
                <span className="font-inter font-semibold md:font-normal text-[14px] md:text-[16px] leading-[24px] md:leading-[25px] text-[#1B0209] underline decoration-[#E83C70] decoration-[3px] underline-offset-[8px] text-opacity-80">
                  {classDetails.sessionCourse.tutors.fullName}
                </span>
              )}
              {classType === "upcoming" && (
                <span className="bg-[#FFECF2] rounded-[40px] px-[12px] md:px-[18px] py-[4px] md:py-[2px] border border-[#FFC9D9] text-[#E83C70] font-inter font-normal text-[12px] md:text-[16px] leading-[24px] md:leading-[26px] text-opacity-80 ">
                  {classStartDate()}
                </span>
              )}
              {classType === "completed" && (
                <span className="bg-[#F2FFF3] rounded-[40px] px-[12px] md:px-[18px] py-[4px] md:py-[2px] border border-[#D1FFD3] text-[#2CBF32] font-inter font-normal text-[12px] md:text-[16px] leading-[24px] md:leading-[26px] text-opacity-80 ">
                  {classEndDate()}
                </span>
              )}
            </div>
          </div>
          {/* open button */}
          <button className="hidden w-[24px] h-[24px] md:flex justify-center items-center">
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 6.5L15 12.5L9 18.5"
                stroke="#0F0220"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      {isClassDetailsModalOpen && (
        <MyClassModal
          classDetails={classDetails}
          classType={classType}
          isOpen={isClassDetailsModalOpen}
          close={() => closeClassDetailsModal()}
          setIsSelectReviewModalOpen={setIsSelectReviewModalOpen}
        />
      )}
      {isSelectReviewModalOpen && (
        <SelectReviewTypeModal
          isOpen={isSelectReviewModalOpen}
          close={() => closeSelectReviewModal()}
          setIsWriteReviewModalOpen={setIsWriteReviewModalOpen}
          setReviewType={setReviewType}
        />
      )}
      {isWriteReviewModalOpen && (
        <WriteReviewModal
          isOpen={isWriteReviewModalOpen}
          close={() => closeWriteReviewModal()}
          reviewType={reviewType}
          classDetails={classDetails}
        />
      )}
    </>
  );
};

export const MyClassCardSkeleton: React.FC = () => {
  return (
    <div className="flex justify-start items-center space-x-[24px] w-full rounded-[14px] border-[1px] border-[#F5F5F5] p-[10px]">
      <div className="w-[172px] h-[109px] bg-gray-300 rounded-[8px] animate-pulse"></div>

      <div className="w-full max-w-[500px] flex flex-col justify-start items-start space-y-[12px]">
        <div className="w-full flex flex-col justify-start items-start space-y-[6px]">
          <div className="w-[80%] h-[22px] bg-gray-300 rounded-md animate-pulse"></div>
        </div>

        <div className="w-full flex flex-col justify-start items-start space-y-[4px]">
          <div className="w-[50%] h-[16px] bg-gray-300 rounded-md animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};
